import { render, staticRenderFns } from "./LongList.vue?vue&type=template&id=74a935fc&scoped=true&"
import script from "./LongList.vue?vue&type=script&lang=ts&"
export * from "./LongList.vue?vue&type=script&lang=ts&"
import style0 from "./LongList.vue?vue&type=style&index=0&id=74a935fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a935fc",
  null
  
)

export default component.exports